module.exports = __webpack_public_path__ + "img/Gallery_1_15.d1680b5c.jpeg";